__turbopack_context__.v({
  "categoryBrandText": "_1jVUxW_categoryBrandText",
  "container": "_1jVUxW_container",
  "purchasedText": "_1jVUxW_purchasedText",
  "textWrapper": "_1jVUxW_textWrapper",
});
